import React, { Component } from 'react';
import Header from '../component/header/header';
import GuideTitle from '../component/guide/guideTitle';
import '../component/guide/guide.css';
import { Link } from 'react-router-dom';

class Guide05 extends Component {
    render() {
        const token = JSON.parse(localStorage.getItem("userInfo"));
        const {prePath} = this.props.guide;
        return (
            <div className="gudie-wrap wait-wrap d-flex flex-column">
                
                <article className="header-wrap"><Header /></article>

                <section className="main-container d-flex flex-column">
                    <GuideTitle guide={this.props.guide} />
                    <div className="body d-flex flex-column align-items-center scroll-wrapper">
                        <div className="container d-flex flex-column align-items-center main-bg">
                            <p>"교시 시작 버튼을 클릭하면 시험이 시작됩니다."</p>
                            <p>교시 시작 전까지 자리에서 대기해 주세요.</p>
                            <p>PC 임의조작 시 부정 행위 등으로 처리될 수 있습니다.</p>
                            <table>
                                <colgroup>
                                    <col width="40%" />
                                    <col width="60%" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>시험명</th>
                                        <td>{token[0].test_name}</td>
                                    </tr>
                                    <tr>
                                        <th>교시</th>
                                        <td>{token[0].test_sec}</td>
                                    </tr>
                                    <tr>
                                        <th>시작 시간</th>
                                        <td>09:00</td>
                                    </tr>
                                    <tr>
                                        <th>종료 시간</th>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="btn-wrap w-100 d-flex justify-content-center align-items-center">
                                <Link to="/examView"><button type="button" className="btn red-btn start-btn">교시 시작</button></Link>
                            </div>
                        </div>
                    </div>
                </section>

                <footer className="footer-wrap w-100 d-flex justify-content-center align-items-center">
                    <div className="page-btn-wrap d-flex justify-content-center align-content-center">
                        <Link to={prePath}>
                            <button className="btn pre-btn">
                                <span className="icon-wrap">
                                    <svg className="icon pre-icon page-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path className="fill" d="M152.182,127.929a.886.886,0,0,1-.629-.261l-7.111-7.111A.889.889,0,1,1,145.7,119.3l6.483,6.483,6.482-6.483a.889.889,0,0,1,1.257,1.257l-7.111,7.111A.884.884,0,0,1,152.182,127.929Z" transform="translate(-140.182 -111.484)" fill="#999"/>
                                    </svg>
                                </span>
                                <b>이전</b>
                            </button>
                        </Link>
                        <div className="page-info"><span className="current-page">5</span>&nbsp;/&nbsp;<span className="total-page">5</span></div>
                        <button className="btn next-btn">
                            <b>다음</b>
                            <span className="icon-wrap">
                                <svg className="icon next-icon page-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path className="fill" d="M152.182,127.929a.886.886,0,0,1-.629-.261l-7.111-7.111A.889.889,0,1,1,145.7,119.3l6.483,6.483,6.482-6.483a.889.889,0,0,1,1.257,1.257l-7.111,7.111A.884.884,0,0,1,152.182,127.929Z" transform="translate(-140.182 -111.484)" fill="#999"/>
                                </svg>
                            </span>
                        </button>
                    </div>
                </footer>
            </div>
        );
    }
}

export default Guide05;